/**
 * ルートレイアウトコンポーネント
 * アプリケーション全体のレイアウトとAIチャットボット機能
 */

import { Outlet } from 'react-router-dom'
import { useState, useCallback } from 'react'
import '../styles/globals.css'
import { Header } from '@/shared/components/Header'
import { UnifiedChatbot, FloatingChatbotButton } from '@/shared/components'
import { ChatResponse, AIActionResult } from '@/types'

/**
 * ルートレイアウトコンポーネント
 */
export function RootLayout() {
    const [isChatModalOpen, setIsChatModalOpen] = useState(false)

    /**
     * AI処理結果のコールバック
     */
    const handleAIResult = useCallback((result: ChatResponse) => {
        console.log('AI処理結果:', result)
    }, [])

    /**
     * AIアクション実行結果のコールバック
     */
    const handleAIActionExecuted = useCallback((results: AIActionResult[]) => {
        console.log('AIアクション実行結果:', results)

        const successfulActions = results.filter(r => r.success)
        if (successfulActions.length > 0) {
            console.log(`${successfulActions.length}件のアクションが正常に実行されました`)
        }
    }, [])

    const handleOpenChat = useCallback(() => {
        setIsChatModalOpen(true)
    }, [])

    const handleCloseChat = useCallback(() => {
        setIsChatModalOpen(false)
    }, [])

    return (
        <div className="font-sans antialiased flex flex-col min-h-screen bg-background text-foreground">
            <Header />
            <main className="flex-1">
                <Outlet />
            </main>

            <FloatingChatbotButton onOpenChat={handleOpenChat} />

            <UnifiedChatbot
                mode="modal"
                isOpen={isChatModalOpen}
                onClose={handleCloseChat}
                onResult={handleAIResult}
                onActionExecuted={handleAIActionExecuted}
            />
        </div>
    )
}
